import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { getBookNotetakerPolicy, getCompanyNotetakerPolicy } from "./api"

export const bookNotetakerPolicyQueryKey = (bookId: string) => ["notetaker-policy", bookId] as const
export const COMPANY_NOTETAKER_POLICY_QUERY_KEY = ["company-notetaker-policy"] as const

export function useBookNotetakerPolicy(bookId: string) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: bookNotetakerPolicyQueryKey(bookId),
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return getBookNotetakerPolicy(context, bookId)
    },
    enabled: !!bookId,
  })
}

export function useCompanyNotetakerPolicy() {
  const getContext = useApiContext()

  return useQuery({
    queryKey: COMPANY_NOTETAKER_POLICY_QUERY_KEY,
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return getCompanyNotetakerPolicy(context)
    },
  })
}
